import { useState, useEffect } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import {
  ArrowRight,
  Target,
  Users,
  Megaphone,
  Palette,
  BarChart3,
  Video,
  ChevronDown,
  Check,
  Star,
  Menu,
  X,
  Phone,
  Mail,
  MapPin } from
'lucide-react';
import { TypeformQuote } from './TypeformQuote';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger } from
'../components/ui/accordion';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/ecqe40ox_Logo1ColorWhite%20%284%29.png';

// Tools & Platforms logos
const toolsLogos = [
{ name: 'Premiere Pro', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/l2mclo9a_1%20%286%29.png' },
{ name: 'Illustrator', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/cq5qsjsh_2%20%287%29.png' },
{ name: 'Photoshop', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/owkd2bh6_3%20%282%29.png' },
{ name: 'Facebook', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/w6qs9me8_4%20%281%29.png' },
{ name: 'Instagram', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/72xzm05i_5%20%281%29.png' },
{ name: 'Google Ads', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/sa455n7m_7.png' },
{ name: 'TikTok', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/1c6jadnf_8.png' },
{ name: 'Shopify', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/1vuyhy1n_10.png', large: true },
{ name: 'Wix Studio Old', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/czrghq5j_11.png', large: true },
{ name: 'WordPress', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/kl9ojo4m_12.png', large: true },
{ name: 'Looker', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/2tiaxssi_13.png' },
{ name: 'OpenAI', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/0wrdv9io_14.png' },
{ name: 'Google Analytics', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/93t1e3id_15.png' },
{ name: 'Wix Studio', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/4ujrlufc_wixstudio.png', invert: true }];


// Client logos
const clientLogos = [
{ name: 'A.Roma', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/mlbyv7n9_aroma.png' },
{ name: 'H&B Aveda', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/48wd3sgx_aveda.png' },
{ name: 'Comus', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/jumoztne_comus.png' },
{ name: 'Giunone Club', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/4j5qszdb_giunone%20%281%29.png' },
{ name: 'Heikos', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/69sutkbe_Heikos_logo_bianco.png', small: true },
{ name: 'Hyundai', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/ehs8lzd7_hyundai.png' },
{ name: 'LDC Hotels', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/votgo2wg_ldc.png' },
{ name: 'Milleocchiali', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/xblv9zi9_milleocchiali.png' },
{ name: 'Nannarella', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/1fnrmh4h_nannarella.png' },
{ name: 'Palazzo Portinari Salviati', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/mn76k2bx_palazzoportinari.png' },
{ name: 'Palazzo Venart', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/19sda5vl_palazzovenart.png' },
{ name: 'Panizzo', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/xp34xu79_panizzo.png' },
{ name: 'Relais Sant Uffizio', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/e0k2267x_relais.png' },
{ name: 'Satur', url: 'https://customer-assets.emergentagent.com/job_2229cee1-7421-43d9-9e64-cbcdb407b29e/artifacts/1xzk1u3o_satur%20%281%29.png' }];


// Services data
const services = [
{
  icon: Target,
  title: 'Strategia di Marketing Digitale',
  description: 'Piano su misura costruito con dati reali e obiettivi misurabili.'
},
{
  icon: Users,
  title: 'Social Media Management',
  description: 'Contenuti, community building, storytelling e riconoscibilità.'
},
{
  icon: Megaphone,
  title: 'Campagne ADV',
  description: 'Acquisizione clienti con targetizzazione avanzata su Meta, Google, TikTok.'
},
{
  icon: Video,
  title: 'Content & Creative Production',
  description: 'Grafica, video e copy che convertono.'
},
{
  icon: Palette,
  title: 'Branding & Visual Identity',
  description: 'Posizioniamo la tua azienda nel mercato con identità distintiva.'
},
{
  icon: BarChart3,
  title: 'Analytics & Performance',
  description: 'Dashboard chiare, KPI definiti e report azionabili.'
}];


// Method steps
const methodSteps = [
{
  number: '01',
  title: 'Analisi e Strategy Audit',
  description: 'Valutiamo la tua situazione attuale. Identifichiamo punti di forza, gap e opportunità.'
},
{
  number: '02',
  title: 'Strategia su Obiettivi',
  description: 'Definiamo una roadmap personalizzata con KPI, target di crescita e strumenti operativi.'
},
{
  number: '03',
  title: 'Attivazione & Ottimizzazione',
  description: 'Campagne, contenuti e processi vengono lanciati con cicli di ottimizzazione basati sui dati.'
},
{
  number: '04',
  title: 'Crescita Continuativa',
  description: 'Non lasciamo nulla al caso: costruiamo un ecosistema che scala nel tempo.'
}];


// USP points
const uspPoints = [
'Approccio data-driven',
'Pianificazione personalizzata',
'Ottimizzazione continua',
'Creatività che converte',
'Un canone mensile chiaro e trasparente',
'Costo completamente deducibile'];


// Testimonials
const testimonials = [
{
  quote: 'Grazie a Creativit abbiamo aumentato i lead qualificati del 220% in 90 giorni.',
  author: 'Cliente PMI',
  sector: 'Settore servizi',
  stars: 5
},
{
  quote: 'La strategia completa ci ha portato a ridurre il costo di acquisizione del 37%.',
  author: 'Brand Moda',
  sector: 'Lusso',
  stars: 5
}];


// FAQs
const faqs = [
{
  question: 'Quanto tempo serve per vedere risultati?',
  answer: 'I primi risultati utili sono già monitorabili dopo il primo ciclo di campagne (4–6 settimane), con report e decisioni ottimizzate.'
},
{
  question: 'Che tipo di aziende seguite?',
  answer: 'PMI, realtà strutturate e brand di lusso con ambizione di crescita reale e sostenibile.'
},
{
  question: 'Serve un contratto lungo?',
  answer: 'Ti proponiamo percorsi flessibili basati su valore e performance, senza vincoli inutili.'
},
{
  question: 'Posso parlare con un consulente prima di partire?',
  answer: 'Sì, dopo il form, puoi prenotare una breve call di allineamento.'
}];


export const LandingPage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { scrollYProgress } = useScroll();
  const opacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMobileMenuOpen]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      {/* Noise overlay */}
      <div className="noise-overlay" />
      
      {/* Background gradients */}
      <div className="fixed inset-0 bg-radial-cyan pointer-events-none" />
      <div className="fixed inset-0 bg-radial-magenta pointer-events-none" />

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 glass border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <a href="/" className="flex items-center" data-testid="logo-link">
              <img
                src={LOGO_URL}
                alt="Creativit"
                className="h-10 w-auto" />
            </a>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              <button
                onClick={() => scrollToSection('servizi')}
                className="text-slate-300 hover:text-white transition-colors">

                Servizi
              </button>
              <button
                onClick={() => scrollToSection('metodo')}
                className="text-slate-300 hover:text-white transition-colors">

                Metodo
              </button>
              <button
                onClick={() => scrollToSection('faq')}
                className="text-slate-300 hover:text-white transition-colors">

                FAQ
              </button>
              <button
                onClick={() => setIsFormOpen(true)}
                className="cta-button px-5 py-2.5 rounded-full font-medium relative z-[9999] flex items-center gap-2 group"
                data-testid="header-cta-button">
                <span className="w-6 h-6 rounded-full bg-white/20 group-hover:bg-black/20 flex items-center justify-center transition-colors">
                  <ArrowRight size={12} className="text-white group-hover:text-black transition-colors" />
                </span>
                <span>Preventivo in 60″</span>
              </button>
            </nav>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(true)}
              className="md:hidden p-2 text-white"
              data-testid="mobile-menu-button">

              <Menu size={24} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 mobile-menu">

          <div className="flex flex-col h-full p-6">
            <div className="flex items-center justify-between mb-12">
              <img src={LOGO_URL} alt="Creativit" className="h-10" />
              <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 text-white">
                <X size={24} />
              </button>
            </div>
            <nav className="flex flex-col gap-6 text-2xl">
              <button onClick={() => scrollToSection('servizi')} className="text-left text-white py-2">
                Servizi
              </button>
              <button onClick={() => scrollToSection('metodo')} className="text-left text-white py-2">
                Metodo
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-left text-white py-2">
                FAQ
              </button>
            </nav>
            <div className="mt-auto">
              <button
              onClick={() => {
                setIsMobileMenuOpen(false);
                setIsFormOpen(true);
              }}
              className="w-full cta-button py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-3 group">
                <span className="w-8 h-8 rounded-full bg-white/20 group-hover:bg-black/20 flex items-center justify-center transition-colors">
                  <ArrowRight size={16} className="text-white group-hover:text-black transition-colors" />
                </span>
                <span>Preventivo in 60″</span>
              </button>
            </div>
          </div>
        </motion.div>
      }

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pt-20" data-testid="hero-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
          <div className="grid md:grid-cols-12 gap-12 items-center">
            <div className="md:col-span-7">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}>

                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.1] mb-6 font-['Grtsk_Tera']">
                  Il tuo partner per il{' '}
                  <span className="text-white">
                    marketing digitale
                  </span>
                </h1>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="text-lg md:text-xl text-slate-300 mb-10 max-w-2xl leading-relaxed space-y-3">

                <p className="flex items-center gap-3">
                  <span className="text-emerald-400">✓</span>
                  <span>Un servizio 100% done-for-you</span>
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-emerald-400">✓</span>
                  <span>Un team di professionisti per la tua azienda</span>
                </p>
                <p className="flex items-center gap-3">
                  <span className="text-emerald-400">✓</span>
                  <span>Ottimizza i costi rispetto ad assumere</span>
                </p>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="flex flex-col sm:flex-row gap-4 relative z-[9999]">

                <button
                  onClick={() => setIsFormOpen(true)}
                  className="cta-button px-8 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-3 group"
                  data-testid="hero-cta-button">
                  <span className="w-8 h-8 rounded-full bg-white/20 group-hover:bg-black/20 flex items-center justify-center transition-colors">
                    <ArrowRight size={16} className="text-white group-hover:text-black transition-colors" />
                  </span>
                  <span>Richiedi preventivo in 60″</span>
                </button>
                <button
                  onClick={() => scrollToSection('metodo')}
                  className="px-8 py-4 rounded-full border border-white/20 text-white font-medium hover:bg-white/5 transition-colors flex items-center justify-center gap-2"
                  data-testid="discover-button">

                  <span>Scopri come funzioniamo</span>
                  <ChevronDown size={20} />
                </button>
              </motion.div>
            </div>

            {/* Stats */}
            <div className="md:col-span-5">
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.3 }}
                className="grid grid-cols-2 gap-6">

                <div className="p-6 rounded-2xl bg-[#0A0A0A] border border-white/20">
                  <div className="stat-number text-4xl mb-2">100+</div>
                  <p className="text-slate-400">aziende seguite</p>
                </div>
                <div className="p-6 rounded-2xl bg-[#0A0A0A] border border-white/20">
                  <div className="stat-number text-4xl mb-2">1 team</div>
                  <p className="text-slate-400">dedicato al tuo progetto</p>
                </div>
                <div className="p-6 rounded-2xl bg-[#0A0A0A] border border-white/20">
                  <div className="stat-number text-4xl mb-2">+300%</div>
                  <p className="text-slate-400">traffico qualificato medio generato</p>
                </div>
                <div className="p-6 rounded-2xl bg-[#0A0A0A] border border-white/20">
                  <div className="stat-number text-4xl mb-2">20+</div>
                  <p className="text-slate-400">professionisti qualificati</p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <motion.div
          style={{ opacity }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2">

          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-2">

            <motion.div className="w-1 h-2 bg-white/50 rounded-full" />
          </motion.div>
        </motion.div>
      </section>

      {/* Problem/Solution Section */}
      <section className="py-24 md:py-32 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16">
            {/* Problem */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}>

              <span className="text-red-400 font-medium mb-4 block">Il problema</span>
              <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
                Investimenti senza visione, dati reali o risultati concreti.
              </h2>
              <p className="text-slate-300 text-lg leading-relaxed">
                Molte aziende investono in marketing digitale senza una visione chiara. 
                Campagne che non performano. Contenuti che non convertono. 
                Strategie che non scalano.
              </p>
            </motion.div>

            {/* Solution */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}>

              <span className="text-emerald-400 font-medium mb-4 block">La soluzione</span>
              <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
                Strategia, creatività, dati e tecnologia in un'unica gestione.
              </h2>
              <p className="text-slate-300 text-lg leading-relaxed mb-8">
                Non sei più tu a inseguire canali, metriche o report — 
                è il marketing che lavora per il tuo business.
              </p>
              <div className="grid grid-cols-2 gap-4">
                {['Lead qualificati', 'Aumento vendite', 'Branding memorabile', 'ROI trasparente'].map((item) =>
                <div key={item} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center" style={{ background: 'linear-gradient(135deg, #43d7ff, #634ced)' }}>
                      <Check size={12} className="text-white" />
                    </div>
                    <span className="text-white">{item}</span>
                  </div>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Tools & Innovation Section */}
      <section className="py-16 md:py-24 relative overflow-hidden" data-testid="tools-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12">

            <h2 className="text-2xl md:text-3xl font-bold mb-4 font-['Grtsk_Tera'] text-slate-300">
              Studiamo e mettiamo al servizio della tua azienda tutte le{' '}
              <span className="text-white">innovazioni ed i trend</span>{' '}
              in ambito digitale
            </h2>
          </motion.div>

          {/* Animated Marquee */}
          <div className="relative group">
            {/* Gradient overlays */}
            <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />
            
            {/* Scrolling container - touch enabled */}
            <div className="overflow-x-auto scrollbar-hide touch-pan-x cursor-grab active:cursor-grabbing" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}>
              <motion.div
                className="flex items-center gap-8 md:gap-12 py-4"
                animate={{ x: ['0%', '-50%'] }}
                transition={{
                  duration: 12,
                  repeat: Infinity,
                  ease: 'linear'
                }}
                whileHover={{ animationPlayState: 'paused' }}
                style={{ willChange: 'transform' }}>

                {/* First set of logos */}
                {toolsLogos.map((tool, index) =>
                <div
                  key={`first-${tool.name}`}
                  className={`flex-shrink-0 flex items-center justify-center ${tool.large ? 'w-36 h-36 md:w-44 md:h-44' : 'w-16 h-16 md:w-20 md:h-20'}`}>

                    <img
                    src={tool.url}
                    alt={tool.name}
                    className="max-w-full max-h-full w-auto h-auto object-contain hover:opacity-100 transition-opacity duration-300 opacity-70"
                    style={{ filter: tool.invert ? 'invert(1)' : 'none' }} />

                  </div>
                )}
                {/* Duplicate set for seamless loop */}
                {toolsLogos.map((tool, index) =>
                <div
                  key={`second-${tool.name}`}
                  className={`flex-shrink-0 flex items-center justify-center ${tool.large ? 'w-36 h-36 md:w-44 md:h-44' : 'w-16 h-16 md:w-20 md:h-20'}`}>

                    <img
                    src={tool.url}
                    alt={tool.name}
                    className="max-w-full max-h-full w-auto h-auto object-contain opacity-70 hover:opacity-100 transition-opacity duration-300"
                    style={{ filter: tool.invert ? 'invert(1)' : 'none' }} />

                  </div>
                )}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="servizi" className="py-24 md:py-32 relative" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16">

            <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
              Marketing & Comunicazione{' '}
              <span className="text-white">Integrati</span>
            </h2>
            <p className="text-slate-300 text-lg max-w-2xl mx-auto">
              Forniamo tutti i servizi necessari per costruire una presenza digitale 
              coerente, efficace e scalabile.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => {
              const IconComponent = service.icon;
              return (
                <motion.div
                  key={service.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="service-card p-8 rounded-2xl bg-[#0A0A0A] border border-white/20 group"
                  data-testid={`service-card-${index}`}>

                  <div className="service-icon mb-6 relative overflow-hidden">
                    {/* White background on hover */}
                    <div
                      className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white" />

                    {/* Icon - white default, black on hover */}
                    <div className="relative z-10 w-12 h-12 flex items-center justify-center">
                      <IconComponent
                        size={24}
                        className="text-white group-hover:text-black transition-colors duration-300" />

                    </div>
                  </div>
                  <h3 className="text-lg font-semibold mb-3 font-['Grtsk_Tera']">{service.title}</h3>
                  <p className="text-slate-400">{service.description}</p>
                </motion.div>);

            })}
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section id="clienti" className="py-20 md:py-28 relative overflow-hidden" data-testid="clients-section">
        {/* Dynamic gradient background */}
        <div className="absolute inset-0">
          <motion.div 
            className="absolute top-0 left-1/4 w-[600px] h-[600px] rounded-full opacity-20"
            style={{ background: 'radial-gradient(circle, rgba(6, 182, 212, 0.15) 0%, transparent 70%)' }}
            animate={{ 
              x: [0, 100, 0],
              y: [0, -50, 0],
            }}
            transition={{ duration: 15, repeat: Infinity, ease: 'easeInOut' }} />
          <motion.div 
            className="absolute bottom-0 right-1/4 w-[500px] h-[500px] rounded-full opacity-20"
            style={{ background: 'radial-gradient(circle, rgba(219, 39, 119, 0.15) 0%, transparent 70%)' }}
            animate={{ 
              x: [0, -80, 0],
              y: [0, 50, 0],
            }}
            transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }} />
        </div>
        
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12">
            <motion.span 
              className="inline-block px-4 py-1.5 mb-6 text-sm font-medium text-white/80 bg-white/5 border border-white/20 rounded-full backdrop-blur-sm"
              whileHover={{ scale: 1.05, borderColor: 'rgba(255, 255, 255, 0.4)' }}>
              Trusted by industry leaders
            </motion.span>
            <h2 className="text-2xl md:text-3xl font-bold mb-4 font-['Grtsk_Tera']">
              Alcuni dei nostri{' '}
              <span className="text-white">clienti</span>
            </h2>
          </motion.div>

          {/* Static Logo Grid */}
          <motion.div 
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-10 gap-y-0 md:gap-x-14 md:gap-y-0 items-center justify-items-center mb-14 -space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, staggerChildren: 0.05 }}>
            {clientLogos.map((client, index) => (
              <motion.div
                key={client.name}
                className={`flex items-center justify-center group ${client.small ? 'h-10 w-20 md:h-12 md:w-24' : 'h-28 w-48 md:h-32 md:w-56'}`}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
                whileHover={{ scale: 1.05 }}>
                <img 
                  src={client.url} 
                  alt={client.name}
                  className="max-h-full max-w-full w-auto h-auto object-contain opacity-95 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ filter: 'brightness(0) invert(1)' }} />
              </motion.div>
            ))}
          </motion.div>

          {/* CTA Button */}
          <motion.div 
            className="text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}>
            <button
              onClick={() => setIsFormOpen(true)}
              className="cta-button px-8 py-4 rounded-full font-semibold text-lg flex items-center justify-center gap-3 group mx-auto"
              data-testid="case-study-cta">
              <span className="w-8 h-8 rounded-full bg-white/20 group-hover:bg-black/20 flex items-center justify-center transition-colors">
                <ArrowRight size={16} className="text-white group-hover:text-black transition-colors" />
              </span>
              <span>Vuoi scoprire i nostri casi studio?</span>
            </button>
          </motion.div>
        </div>
      </section>

      {/* Method Section */}
      <section id="metodo" className="py-24 md:py-32 relative" data-testid="method-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-16">

            <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
              Il Metodo <span className="text-white">Creativit</span>
            </h2>
            <p className="text-slate-300 text-lg max-w-2xl">
              Un processo collaudato che porta risultati concreti e misurabili.
            </p>
          </motion.div>

          <div className="space-y-8">
            {methodSteps.map((step, index) =>
            <motion.div
              key={step.number}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="method-step flex gap-8"
              data-testid={`method-step-${index}`}>

                <div className="flex-shrink-0">
                  <motion.div 
                    className="w-12 h-12 rounded-full flex items-center justify-center font-bold font-['Grtsk_Tera'] relative overflow-hidden border border-white/20"
                    animate={{ 
                      backgroundColor: ['rgba(255,255,255,0)', 'rgba(255,255,255,1)', 'rgba(255,255,255,1)', 'rgba(255,255,255,0)'],
                      color: ['#FFFFFF', '#000000', '#000000', '#FFFFFF'],
                      borderColor: ['rgba(255,255,255,0.2)', 'rgba(255,255,255,1)', 'rgba(255,255,255,1)', 'rgba(255,255,255,0.2)']
                    }}
                    transition={{ 
                      duration: 3, 
                      repeat: Infinity, 
                      ease: 'easeInOut',
                      times: [0, 0.4, 0.6, 1]
                    }}>
                    {step.number}
                  </motion.div>
                </div>
                <div className="pt-1">
                  <h3 className="text-lg font-semibold mb-2 font-['Grtsk_Tera']">{step.title}</h3>
                  <p className="text-slate-400 text-lg">{step.description}</p>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>

      {/* USP Section */}
      <section className="py-24 md:py-32 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}>

              <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
                Perché scegliere <span className="text-white">Creativit</span>
              </h2>
              <p className="text-slate-300 text-lg mb-8">
                Creativit non è una semplice esecutrice. Siamo un team strategico e operativo 
                che accompagna l'azienda come se fosse un reparto di marketing interno.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {uspPoints.map((point) =>
                <div key={point} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 bg-white/20 border border-white/30">
                      <Check size={12} className="text-white" />
                    </div>
                    <span className="text-white">{point}</span>
                  </div>
                )}
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="relative">

              <div className="absolute inset-0 rounded-3xl blur-3xl bg-white/10" />
              <div className="relative p-8 md:p-12 rounded-3xl bg-[#0A0A0A] border border-white/20">
                <div className="stat-number text-7xl md:text-8xl mb-4">100+</div>
                <p className="text-xl text-white mb-2 font-['Grtsk_Tera']">Aziende</p>
                <p className="text-slate-400">
                  hanno già scelto Creativit per far crescere il loro business.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-24 md:py-32 relative" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16">

            <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
              Cosa dicono i nostri <span className="text-white">clienti</span>
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) =>
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className="testimonial-card p-8 rounded-2xl"
              data-testid={`testimonial-${index}`}>

                <div className="flex gap-1 mb-6">
                  {[...Array(testimonial.stars)].map((_, i) =>
                <Star key={i} size={20} className="fill-yellow-400 text-yellow-400" />
                )}
                </div>
                <blockquote className="text-lg md:text-xl text-white mb-6 font-['Grtsk_Tera'] leading-relaxed">
                  "{testimonial.quote}"
                </blockquote>
                <div>
                  <p className="text-white font-medium">{testimonial.author}</p>
                  <p className="text-slate-400">{testimonial.sector}</p>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="preventivo" className="py-24 md:py-32 relative" data-testid="cta-section">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}>

            <h2 className="text-2xl md:text-4xl font-bold mb-6 font-['Grtsk_Tera']">
              Richiedi un preventivo in soli{' '}
              <span className="text-white">60 secondi</span>
            </h2>
            <p className="text-slate-300 text-lg md:text-xl mb-10 max-w-2xl mx-auto">
              Completa il nostro form dinamico e ottieni una proposta su misura per la tua azienda. 
              Niente call lunghe. Niente offerte generiche. Solo soluzioni chiare e immediate.
            </p>
            <button
              onClick={() => setIsFormOpen(true)}
              className="cta-button px-10 py-5 rounded-full font-semibold text-xl flex items-center justify-center gap-3 mx-auto group"
              data-testid="main-cta-button">
              <span className="w-10 h-10 rounded-full bg-white/20 group-hover:bg-black/20 flex items-center justify-center transition-colors">
                <ArrowRight size={20} className="text-white group-hover:text-black transition-colors" />
              </span>
              <span>Richiedi Preventivo in 60″</span>
            </button>
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-24 md:py-32 relative" data-testid="faq-section">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16">

            <h2 className="text-2xl md:text-3xl font-bold mb-6 font-['Grtsk_Tera']">
              Domande <span className="text-white">Frequenti</span>
            </h2>
          </motion.div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) =>
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-[#0A0A0A] border border-white/20 rounded-xl px-6 data-[state=open]:border-white/40"
              data-testid={`faq-item-${index}`}>

                <AccordionTrigger className="text-left text-lg font-medium py-5 hover:no-underline text-white">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            )}
          </Accordion>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-16 border-t border-white/20" data-testid="footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            {/* Logo & Description */}
            <div>
              <img src={LOGO_URL} alt="Creativit" className="h-10 mb-6" />
              <p className="text-slate-400">
                L'agenzia che trasforma la tua presenza online in clienti reali, 
                visibilità e performance scalabili.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-white font-semibold mb-4 font-['Grtsk_Tera']">Link Rapidi</h4>
              <nav className="space-y-3">
                <button
                  onClick={() => scrollToSection('servizi')}
                  className="block text-slate-400 hover:text-white transition-colors">

                  Servizi
                </button>
                <button
                  onClick={() => scrollToSection('metodo')}
                  className="block text-slate-400 hover:text-white transition-colors">

                  Metodo
                </button>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="block text-slate-400 hover:text-white transition-colors">

                  FAQ
                </button>
              </nav>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-semibold mb-4 font-['Grtsk_Tera']">Contatti</h4>
              <div className="space-y-3">
                <a
                  href="https://maps.google.com/?q=Piazza+Bortolo+Belotti+48,+00139+Roma"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                  <MapPin size={18} />
                  <span>Piazza Bortolo Belotti 48, 00139 Roma</span>
                </a>
                <a
                  href="tel:+393892625299"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                  <Phone size={18} />
                  <span>+39 389 262 5299</span>
                </a>
                <a
                  href="mailto:info@creativit.it"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                  <Mail size={18} />
                  <span>info@creativit.it</span>
                </a>
                <a
                  href="mailto:creativit@pec.buffetti.it"
                  className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">

                  <Mail size={18} />
                  <span>PEC: creativit@pec.buffetti.it</span>
                </a>
              </div>
              <p className="text-slate-500 text-sm mt-4">P.IVA: 16385541004</p>
            </div>
          </div>

          <div className="section-divider my-12" />

          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} Creativit. Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="https://www.iubenda.com/privacy-policy/62865113"
                className="iubenda-white no-brand iubenda-noiframe iubenda-embed text-slate-500 hover:text-white transition-colors text-sm"
                title="Privacy Policy"
                data-testid="footer-privacy">
                Privacy Policy
              </a>
              <a
                href="https://www.iubenda.com/privacy-policy/62865113/cookie-policy"
                className="iubenda-white no-brand iubenda-noiframe iubenda-embed text-slate-500 hover:text-white transition-colors text-sm"
                title="Cookie Policy"
                data-testid="footer-cookie">
                Cookie Policy
              </a>
              <a href="https://www.instagram.com/creativit.agency/" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-instagram">
                Instagram
              </a>
              <a href="https://www.linkedin.com/company/creativit-agency/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-linkedin">
                LinkedIn
              </a>
              <a href="https://www.facebook.com/creativitMedia" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-facebook">
                Facebook
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <motion.a
        href="https://wa.me/393892625299"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 group"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="whatsapp-button">

        <div className="relative">
          {/* Animated gradient background */}
          <motion.div
            className="absolute inset-0 rounded-full opacity-80"
            style={{
              background: 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #075E54 100%)',
              backgroundSize: '200% 200%'
            }}
            animate={{
              backgroundPosition: ['0% 0%', '100% 100%', '0% 0%']
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'linear'
            }} />

          {/* Button content */}
          <div className="relative flex items-center justify-center w-14 h-14 rounded-full shadow-lg group-hover:shadow-[0_0_25px_rgba(37,211,102,0.5)]">
            <svg
              viewBox="0 0 24 24"
              className="w-7 h-7 text-white fill-current">

              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </div>
          {/* Pulse effect */}
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)'
            }}
            animate={{
              scale: [1, 1.5, 1.5],
              opacity: [0.5, 0, 0]
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeOut'
            }} />

        </div>
      </motion.a>

      {/* Typeform Quote Modal */}
      <TypeformQuote isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </div>);

};

export default LandingPage;